export const GetCreditDetailsUrl = (): string =>
  '/ClubLink/GetCustomerActivityDetails';
